import { SectionBlockType_sectionblock } from "@components/SectionBlock/queries/contentfulTypes/SectionBlockType";

const isColoredSection = (backgroundColor: string): boolean => {
  return ["Ljusblå", "Ljusgrön", "Gul"].includes(backgroundColor);
};

const shouldRemoveBottomMargin = (contentAreaItems: Array<any>): boolean => {
  if (contentAreaItems?.length < 1) return false;
  const block = contentAreaItems?.[contentAreaItems?.length - 1];
  if (block?.hasOwnProperty("sectionblock")) {
    const sectionblock: SectionBlockType_sectionblock = block?.sectionblock;
    if (sectionblock.isWide && isColoredSection(sectionblock.backgroundColor)) {
      return true;
    }
  }
  return false;
};

const shouldRemoveTopMargin = (contentAreaItems: Array<any>, useHero: boolean): boolean => {
  if (contentAreaItems?.length < 1 || !useHero) return false;
  const block = contentAreaItems[0];
  if (block?.hasOwnProperty("sectionblock")) {
    const sectionblock: SectionBlockType_sectionblock = block?.sectionblock;
    if (sectionblock.isWide && isColoredSection(sectionblock.backgroundColor)) {
      return true;
    }
  }
  return false;
};

export { isColoredSection, shouldRemoveTopMargin, shouldRemoveBottomMargin };
